;(function($) {
    $.fn.counter = function(options) {
        var settings = $.extend({
            start: 0,
            end: 100,
            decimals: 0,
            easing: 'swing',
            duration: 400,
            thousandsSeparator: '.',
            decimalsSeparator: ','
        }, options);

        var $this = $(this);

        var getFormattedText = function(count) {
            var showCount = parseFloat(count);

            if (isNaN(showCount)) {
                showCount = 0;
            }

            showCount = showCount.toFixed(settings.decimals);

            var showCountParts = showCount.split('.');
            var number         = showCountParts[0];
            var decimals       = showCountParts[1];

            showCount = number.replace(/\B(?=(\d{3})+(?!\d))/g, settings.thousandsSeparator);

            if (decimals != undefined) {
                showCount += settings.decimalsSeparator + decimals;
            }

            return showCount;
        };

        $({count: settings.start}).animate({count: settings.end}, {
            duration: settings.duration,
            easing: settings.easing,
            step: function() {
                var formattedText = getFormattedText(this.count);
                $this.data('counter-current', this.count).html(formattedText);
            },
            complete: function() {
                var formattedText = getFormattedText(settings.end);
                $this.data('counter-current', this.count).html(formattedText);
            }
        });
    };
}(jQuery));